document.addEventListener(
  'click',
  function (event) {
    var link = event.target.closest(
      '.lion-header__join-buttons a[href^="/account/login"]'
    );
    if (!link) return;

    var returnTo = window.location.pathname + window.location.search;
    var url = new URL(link.getAttribute('href'), window.location.origin);
    url.searchParams.set('return_to', returnTo);
    link.setAttribute('href', url.pathname + url.search);
  },
  true
);
